import React from 'react';
import PropTypes from 'prop-types';
import Switch from './ui/Switch';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

class LiveEventModalElements extends React.Component{

    state = {
        showOfferTags: this.props.event.showOfferTags ? this.props.event.showOfferTags.split(',') : []
    };

    handleChange = (tags, key) => {
        this.setState({[key]: tags});
        this.props.updateEvent(key, tags.join(','));
    };

    render() {
        return (
            <div className="tab-panel">
                <div className="column column-wide">
                    <Switch checked={this.props.event.offerShowing === "true"} label="Show offer (only during Live mode)" onChange={checked => this.props.updateEvent("offerShowing", checked) } />
                    <Switch checked={this.props.event.replayMode === "true"} label="Replay mode" onChange={checked => this.props.updateEvent("replayMode", checked) } />
                    <label>In replay mode, show the offer if they have these tags</label>
                    <TagsInput value={this.state.showOfferTags === "" ? [] : this.state.showOfferTags} onChange={tags => this.handleChange(tags, 'showOfferTags')} />
                </div>
            </div>
        );
    }
}

LiveEventModalElements.propTypes = {
    event: PropTypes.object.isRequired,
    updateEvent: PropTypes.func.isRequired
}

export default LiveEventModalElements;


/** WEBPACK FOOTER **
 ** ./src/components/LiveEventModalElements.js
 **/